import valueFunctionQueryParam from './valueFunctionQueryParam';
import valueFunctionExternalSource from './externalSource';
import * as T from '../types';
import valueFunctionURL from './valueFunctionURL';

const valueFunctions = {
  queryParam: valueFunctionQueryParam,
  url: valueFunctionURL,
  externalSource: valueFunctionExternalSource
};

type ValueFunctionsUnsanitizedType = typeof valueFunctions;
export type ValueFunctionsType = {
  [key in keyof ValueFunctionsUnsanitizedType]: T.CheckValueFunctionType<
    Parameters<ValueFunctionsUnsanitizedType[key]>[0],
    Parameters<ValueFunctionsUnsanitizedType[key]>[1]
  >;
};

export default valueFunctions as ValueFunctionsType;
